import  { useState, useEffect } from "react";
import { TableContainer, Paper } from "@mui/material";
import { Typography } from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

// material-ui
import Box from "@mui/material/Box";

import { Request_Get_Registers_Fuzzy_Search } from "../../Registers/api/Request_Get_Registers_Fuzzy_Search";
import { StaffuseAuth } from "../../../security/StaffuseAuth";
import SimpleTableHeader from "../../../components/Tables/SimpleTableHeader";
import SimpleTableCell from "../../../components/Tables/SimpleTableCell";
import { Send_Pre_SXP_Programme_Emails } from "./api/Send_Pre_SXP_Programme_Emails";

function SXPPreProgramme() {
  const { logout } = StaffuseAuth();

  //-----------------------------Get Data---------------------------------------------
  // Assuming you have a state to store the fetched data
  const [Registers, setRegisters] = useState([
    {
      BasicInfo: {
        First_Name: "NOT FOUND",
        Created_At: "2024-10-01",
        ProgrammeTitle: "Summer Programme",
        ProgrammeVarient: "In Person",
        ProgrammeDate: "(3rd November 2024)",
      },
      Notes: [
        {
          Note: "Pre Programme Email Sent",
          DateTime: "2024-10-07T10:00:00Z",
        },
        {
          Note: "Pre Programme Email Sent",
          DateTime: "2024-10-08T10:00:00Z",
        },
        {
          Note: "Pre Programme Email Sent",
          DateTime: "2024-10-09T10:00:00Z",
        },
      ],
    },
  ]);
  //Load those who may need an email
  useEffect(() => {
    Request_Get_Registers_Fuzzy_Search(
      "Registers_2025",
      "All",
      {
        ProgrammeDate: "18th August",
        ProgrammeVarient: "week",
       GotPreProgrammeEmail: "No",
      },
      10000,
      setRegisters,
      logout
    );
  }, []);

  const determineDueEmail = (customer) => {
     //return true
    const notes = customer.Notes || [];
    if (notes.length === 0) {
      return true;
    }
    const emailNotes = notes.filter((note) =>
      ["Pre Programme Email Sent"].includes(note.Note)
    );
    const programmeTitle = customer?.BasicInfo?.ProgrammeTitle || "";
    if (!programmeTitle.toLowerCase().includes("summer")) {
      return false;
    }
    if (customer.MetaData?.Archived === "Yes") {
      return false;
    }
    if (emailNotes.length === 0) {
      return true;
    }
    return false;
  };

  function handleSend(e, chosenArray) {
    e.preventDefault();

    const AttendeesToSend = chosenArray.filter((Attendee) =>
      determineDueEmail(Attendee)
    );

    AttendeesToSend.forEach((Attendee) => {
      console.log("Attendee");
      console.log(Attendee.BasicInfo?.First_Name);
      let newNote = {
        DateTime: new Date().toISOString(),
        Note: "Pre Programme Email Sent",
        Staff_ID: localStorage.getItem("_id"),
      };
      console.log("Pre Programme Email Sent");
      Send_Pre_SXP_Programme_Emails(
        { Attendee: Attendee, newNote: newNote },
        logout
      );
    });
    console.log("-----End Send-----");
  }

  //-----------------------------Return--------------------------------------------

  return (
    <div
      style={{
        backgroundColor: "#e5e5e5",
        minHeight: "93vh",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row", // Add this line
          flexWrap: "wrap",
          justifyContent: "flex-start",
          // gap: "20px",
          // height: "100%",
        }}
      >
        <div
          name="space"
          style={{ width: "100%", height: "10px", flex: "0 1 auto" }}
        ></div>
        <Box
          component="main"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            maxWidth: "95%",
            maxHeight: "800px",
            flexGrow: 1,
            p: 1,
          }}
        >
          <Typography variant="h6" gutterBottom>
            View SEF Emails
          </Typography>
          <button
            style={{ width: "100px" }}
            onClick={(e) => handleSend(e, Registers)}
          >
            Send
          </button>

          <TableContainer
            component={Paper}
            sx={{
              width: "100%",
              margin: "0 auto",
              overflow: "auto",
            }}
          >
            <Table
              aria-label="simple table"
              sx={{
                border: "1px solid #e0e0e0",
                tableLayout: "fixed",
              }}
            >
              <TableHead>
                <TableRow>
                                    <>{SimpleTableHeader("id")}</>
                  <>{SimpleTableHeader("Name")}</>
                  <>{SimpleTableHeader("Title")}</>
                  <>{SimpleTableHeader("Date")}</>
                  <>{SimpleTableHeader("Varient")}</>
                  <>{SimpleTableHeader("EC")}</>
                  <>{SimpleTableHeader("Submission Date")}</>
                  <>{SimpleTableHeader("SEF Stage")}</>
                  <>{SimpleTableHeader("Timing Stage")}</>{" "}
                  <>{SimpleTableHeader("EC")}</>
                  <>{SimpleTableHeader("Send")}</>
                </TableRow>
              </TableHead>
              <TableBody>
                {Registers.map((Register, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      backgroundColor:
                        Register?.MetaData?.Archived === "Yes"
                          ? "rgba(139, 0, 0, 0.5)"
                          : Register?.MetaData?.Reserved === "Yes"
                          ? "rgba(0, 0, 139, 0.5)"
                          : Register?.MetaData?.Bursary === "Yes"
                          ? "rgba(144, 238, 144, 0.5)"
                          : "",
                      "&:hover": {
                        backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                        "& .MuiTableCell-root": {
                          padding: "8px",
                          wordWrap: "break-word",
                          overflowWrap: "break-word", // Adjust padding here to make cells smaller
                        },
                      },
                    }}
                  >
                                        {SimpleTableCell(Register?._id)}

                    {SimpleTableCell(
                      Register?.BasicInfo?.First_Name +
                        " " +
                        Register?.BasicInfo?.Last_Name
                    )}
                    {SimpleTableCell(Register?.BasicInfo?.ProgrammeTitle)}
                    {SimpleTableCell(Register?.BasicInfo?.ProgrammeDate)}
                    {SimpleTableCell(Register?.BasicInfo?.ProgrammeVarient)}
                    {SimpleTableCell(
                      Register?.IPInfo?.EC_ID &&
                        Register?.IPInfo?.EC_ID !== "" &&
                        Register?.IPInfo?.EC_ID !== null &&
                        Register?.IPInfo?.EC_ID !== undefined
                        ? "EC Booking"
                        : "Non EC Booking"
                    )}
                    {SimpleTableCell(Register?.SEFInfo?.SEFSubmissionDate)}
                    {SimpleTableCell(Register?.SEFInfo?.SEF)}
                    {SimpleTableCell(
                      Register?.SummerArrivalDeparture?.Progress
                    )}
                    {SimpleTableCell(Register.IPInfo?.EC_ID)}
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{
                        padding: "8px",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {determineDueEmail(Register) ? (
                        <button onClick={(e) => handleSend(e, [Register])}>
                          Send
                        </button>
                      ) : (
                        <></>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </div>
    </div>
  );
}

export default SXPPreProgramme;
